module.exports = __webpack_public_path__ + "img/bg_ewaskat.023f617b.png";